export default class StoreInfo {
  static campaigns = {
    inProgress: new Set()
  };
}
